<template>
  <div>
    <div class="add-jobs-work">
      <div class="search-jobs-work">
        <div :class="['arrow-main' , {hide: hideAll}]" @click="hideAllHandler">
          <i :class="'fas fa-chevron-right'"></i>
        </div>
        <el-input placeholder="Поиск ..." v-model="search" class="input-search">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
    </div>

    <div class="add-main-job add-main-job-des" style="padding-right: 38px; box-sizing: border-box">
      <div class="plus-btn" v-if="isEditable && isShowPlus && !hideAll"
           @click="openJob(null, null, null)">
        +
      </div>
    </div>


    <div v-for="(object, index) in format(objects)" :key="object.id" v-show="(object.name || '').includes(search)">
      <div class="main-object-block">
        <div class="object-container" v-if="object.name">
          <div class="object-name">
            <div style="display:flex; align-items: center">
              <div @click="hideLines(index)" class="arrow-main"
                   :class="['arrow-main' , {hide: hides[index]}]">
                <i class="fa fa-chevron-right"></i>
              </div>
              <div class="name" v-if="object.name">
                <span
                  class="name-click"
                  @click="openObjectEdit(object, obj)"
                  v-for="(obj, index) in (object.name || '').split(' > ')"> {{ index > 0 ? ' > ' : '' }} {{
                    obj
                  }}</span>
              </div>
              <div class="name" v-else>
                <span>Без объекта</span>
              </div>
            </div>
          </div>
          <div class="add-main-job ">
            <span style="white-space: nowrap"
                  :style="{color: pStatus(calcObjectPlan(object))}">{{ calcObjectPlan(object) }} %</span>
          </div>
        </div>


        <div class="desktop-show-create">
          <el-table
            :border="true"
            v-if="object.jobs && object.jobs.length"
            v-show="!hides[index]"
            :data="object.jobs"
            style="width: 100%">
            <el-table-column
              min-width="200"
              prop="job.name"
              label="Наименование"
            >
              <template slot-scope="scope">
                <div style="display: flex; align-items: center">
                  <span
                    @click="openJob(object, object.jobs[scope.$index], scope.$index)"
                    :class="{work_custom: scope.row.job.work_type === 'custom'}"
                    style="text-align: left; font-size: 15px; margin-bottom: 4px; margin-left: 4px; cursor: pointer">
              {{
                      scope.row.name || scope.row.job.name
                    }}, {{
                      scope.row.job.unit && ((scope.row.unit.label || scope.row.unit) || (scope.row.job.unit.label || scope.row.job.unit))
                    }}
            </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Всего" v-if="isShowPlan(object)">
              <el-table-column
                prop="job.allPlan"
                v-if="isShowPlan(object)"
                label="План"
                width="100">
                <template slot-scope="scope">
                  {{ toFixedWithoutZero(scope.row.job.plan || '') }}
                </template>
              </el-table-column>

              <el-table-column
                prop="job.allValue"
                v-if="isShowPlan(object)"
                label="Факт"
                width="100">
                <template slot-scope="scope">
                  {{ scope.row.job.totalActualValue || scope.row.job.totalValue || '' }}
                </template>
              </el-table-column>
            </el-table-column>

            <el-table-column label="Производительность" v-if="$store.state.project.workorder.analytics === 'progress'">
              <el-table-column
                prop="job.allPlan"
                label="Норма"
                width="100">
                <template slot-scope="scope">
                  <span class="precent"
                        :style="{color: calcProfNorm(scope.row) > calcProfFact(scope.row) ?  '#7CB342' : '#D32F2F' }">
                  {{ parseFloat(Number(calcProfNorm(scope.row)).toFixed(1)) }}
                  </span>

                </template>
              </el-table-column>

              <el-table-column
                prop="job.allValue"
                label="Факт"
                width="100">
                <template slot-scope="scope">
                  {{ calcProfFact(scope.row) }}
                </template>
              </el-table-column>
            </el-table-column>

            <el-table-column
              prop="plan"
              label="План"
              width="100">
            </el-table-column>

            <el-table-column
              prop="value"
              label="Факт"
              width="100">
              <template slot-scope="scope">
                {{ calcValue(scope.row) }}
              </template>
            </el-table-column>

            <el-table-column
              prop="value"
              label="%"
              width="100">
              <template slot-scope="scope">
              <span class="precent"
                    :style="{color: pStatus(calculatePercentage(calcValue(scope.row), scope.row.plan)), fontWeight: '500', whiteSpace: 'nowrap'}">{{
                  calculatePercentage(calcValue(scope.row), scope.row.plan)
                }} % </span>
              </template>
            </el-table-column>

            <el-table-column width="46">
              <template slot-scope="scope">
                <i class="fa fa-chevron-right"
                   @click="openJobDialog(object, scope.row, scope.$index, calcValue(scope.row))"></i>
              </template>
            </el-table-column>
          </el-table>
        </div>


        <div class="job-container mob-show-create" v-for="(job, i) in object.jobs" v-show="!hides[index]">
          <div style="display: flex; justify-content: space-between; align-items: center; flex: 1; width: 100%;">
            <span @click="openJob(object, job, i)"
                  style="text-align: left; font-size: 14px; margin-bottom: 4px; margin-left: 4px; cursor: pointer">
              {{ job.name }}, {{ job.unit && (job.unit.label || job.unit) }}
            </span>
            <span class="precent"
                  :style="{color: pStatus(calculatePercentage(calcValue(job), job.plan)), fontWeight: '500' , whiteSpace: 'nowrap'}">{{
                calculatePercentage(calcValue(job), job.plan, 0)
              }} % </span>
          </div>
          <div class="job-inputs">
            <el-input class="input" v-model="job.plan"></el-input>
            <el-input class="input" :value="calcValue(job)"></el-input>
            <i class="fa fa-chevron-right" v-if="$route.params.id"
               @click="openJobDialog(object, job, i, calcValue(job))"></i>
          </div>
        </div>
        <div v-show="!hides[index]" class="add-main-job add-main-job-des"
             style="padding-right: 38px; box-sizing: border-box">
          <div class="plus-btn" v-if="isEditable" @click="openJob(object, {}, null)">
            +
          </div>
        </div>
      </div>
    </div>

    <add-object-jobs-work :isEditable="isEditable" v-if="isEditable" ref="addObject" @update="addObjects"
                          @remove="remove"/>
    <create-jobs-work :isEditable="isEditable" @remove="removeJob" ref="createJobsWork" @save="createJobs"
                      @copy="copyJob"/>
    <add-jobs :approve="approve" :isEditable="isEditable" @save="addJobs" :user="user" :main-form="mainForm"
              @remove="removeReport"
              :workTypeOptions="work_type_options" :currentIndex="index"
              :options_works="options_works"
              ref="addJobs"/>

    <el-button
      class="mob-show-create"
      v-if="isEditable"
      @click="openObj"
      size="small"
      type="primary" style="width: 100%; margin-top: 8px">Добавить объект
    </el-button>

    <el-button
      class="desktop-show-create"
      v-if="isEditable"
      @click="openObj"
      type="primary" style="width: 110px; margin-top: 8px">+ Объект
    </el-button>
  </div>
</template>

<script>
import AddObjectJobsWork from "./AddObjectJobsWork";
import CreateJobsWork from "./CreateJobsWork";
import CreateJobsReport from "./CreateJobsReport";
import AddJobs from "./AddJobs";
import {fetchIndex} from "../../../../firestore/reports";
import firebase from "firebase";
import {calculatePercentage, pStatus, toFixedWithoutZero} from "../../../../utils/numberUtils";
import _ from "lodash";
import {v4 as uuidv4} from "uuid";
import dayjs from "dayjs";

export default {
  name: "AddJobsWork",
  components: {AddJobs, CreateJobsReport, CreateJobsWork, AddObjectJobsWork},
  props: ['index', 'inputObjects', 'mainForm', 'options_works', 'user', 'approve', 'isEditable'],
  data() {
    return {
      search: '',
      objects: [],
      hides: {},
      jobs: {},
      formIndex: 0,
      hideAll: false,
      work_type_options: [],
      removeIds: [],
      showConfig: null
    }
  },
  async mounted() {
    this.formIndex = await fetchIndex()
    this.objects = this.inputObjects || []


    firebase.firestore()
      .collection('projects')
      .doc(this.$store.state.project.id)
      .collection('show_config')
      .get().then((data) => {
      const result = {}

      data.forEach((sub) => {
        result[sub.id] = sub.data();
      })

      this.showConfig = result
    })


    this.getWorkType('job')

    for (let objIndex in this.objects) {
      for (let jobIndex in this.objects[objIndex].jobs) {
        const job = this.objects[objIndex].jobs[jobIndex]
        if (job.originalId) {
          if(this.jobs[job.originalId] === undefined) {
            const newJob = (await firebase.firestore()
              .collection('projects')
              .doc(this.$store.state.project.id)
              .collection('jobs').doc(job.originalId).get()).data()

            this.jobs[job.originalId] = newJob && newJob.totalValue || null
          }



          if(this.objects[objIndex].jobs[jobIndex].job ) {
            this.objects[objIndex].jobs[jobIndex].job.totalActualValue =  this.jobs[job.originalId]
          }

        }
      }
    }

    this.objects = [...this.objects]
  },
  computed: {
    isShowPlus() {
      return !this.objects.find(({name, index}) => !name && !index)
    }
  },
  watch: {
    objects: {
      handler(e) {
        this.$emit('update', e)
      },
      deep: true
    }
  },
  methods: {
    isShowPlan(object) {
      if (!this.showConfig) {
        return false
      }
      let config = this.showConfig[object.id]
      if (!this.showConfig[object.id]) {
        config = this.showConfig['all']
      }

      return !config || config.plan
    },
    findInp(ob, inputs) {
      let input = inputs.job.inputs.find(({id}) => id === ob.id) || {}

      if (ob === 'zone') {
        input = inputs.job.inputs.find(({type}) => type === 'zone') || {}
      }
      if (input.selectValues) {
        let result = ''
        Object.values(input.selectValues).forEach((e) => {
          result = result + e.name + '\n '
          Object.values(e.values).forEach((d) => {
            result = result + d.value + '\n'
          })

        })
        return result.trim()
      }


      return input.value && input.value.label ? input.value.label : input.value
    },
    toFixedWithoutZero,
    hideAllHandler() {
      this.hideAll = !this.hideAll

      if (this.hideAll) {
        this.objects.forEach((j, i) => {
          this.hides[i] = true
        })
      } else {
        this.objects.forEach((j, i) => {
          this.hides[i] = false
        })
      }

      this.hides = {...this.hides}

    },
    pStatus,
    calculatePercentage,
    getRemoveIds() {
      return this.removeIds;
    },
    getTotalValueAndPlan(job) {
      let valueR = 0, planR = 0

      try {

        if (job) {
          job.reports.forEach(({jobs}) => {
            try {
              if (jobs) {
                jobs.forEach((job) => {
                  valueR += Number(job.value)
                  planR += Number(job.job.plan)
                })
              }
            } catch (e) {
            }
          })
        }
      } catch (e) {
      }

      return {value: valueR, plan: planR}
    },
    removeJob(job) {
      this.removeIds.push(job.removeId)

      const index = this.objects.findIndex(({id}) => job.structureObj === id)

      if (index !== -1) {
        this.objects[index].jobs.splice(job.editId, 1)
        this.objects = [...this.objects]
      }
    },
    hideLines(index) {
      if (!this.hides[index]) {
        this.hides[index] = true
        return this.hides = {...this.hides}
      }
      this.hides[index] = !this.hides[index]
      this.hides = {...this.hides}

    },
    calcObjectPlan(object) {
      let result = {
        plan: 0,
        value: 0
      }

      object.jobs.forEach((p) => {
        result.plan += Number(p.plan || 0)
        result.value += this.calcValue(p)
      });

      return calculatePercentage(result.value || 0, result.plan || 0, 0) || 0
    },
    getWorkType(type) {
      return new Promise(() => {
        const result = [];
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('works_type')
          .where('type', '==', type).get().then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              data: data,
              value: subDoc.id,
              label: (data.name || data.id || '') + (data.stamp ? ' ' + data.stamp : ''),
            });
          });
          this.work_type_options = result;
        });
      });
    },
    openJobDialog(obj = {}, job, index, calcValue) {
      const id = obj ? obj.id : null;
      this.$refs.addJobs.open(job, index, id, calcValue)
    },
    format(objects) {
      return JSON.parse(JSON.stringify(objects))
    },
    openJob(obj = {}, job = null, index = null) {
      const id = obj ? obj.id : null;
      this.$refs.createJobsWork.openHandler(id, job, index)
    },
    calcProfNorm(job) {

      let norm = 0

      const unit_fo_value = Number((job.work_type && job.work_type.data && job.work_type.data.unit_for_value) || 0)
      try {

        job.reports.forEach((r) => {
          r.jobs.forEach((data) => {
            norm += Number(data.job.value)
          })
        })
      } catch (e) {}
      const result = (unit_fo_value * norm)
      return result || ''
    },
    calcProfFact(job) {
      let fact = 0

      try {

        job.reports.forEach((r) => {
          if (r.PROF && r.PROF.time !== undefined) {
            fact += Number(r.PROF.time) * Number(r.PROF.value)
          }
        })
      } catch (e) {}
      return fact || ''
    },
    calcValue(job) {
      if (!job || !job.reports || !job.reports.length) {
        return 0
      }

      let i = 0

      job.reports.forEach(({jobs}) => {
        jobs.forEach(({job}) => {
          i += Number(job.value)

        })
      })

      return i
    },
    copyJob(form) {
      const index = this.objects.findIndex(({id}) => form.structureObj === id)

      if (index !== -1) {
        this.objects[index].jobs.push({...form.form, reports: []})

      }
    },
    createJobs(form) {

      const index = this.objects.findIndex(({id}) => form.structureObj === id)

      if (form.editId === null && index !== -1) {
        this.objects[index].jobs.push(form.form)

        return this.objects = [...this.objects]
      }

      if (index === -1) {
        this.objects.push({
          id: null,
          index: null,
          name: null,
          parentId: null,
          jobs: [form.form]
        })
        return this.objects = [...this.objects]
      }


      if (index !== -1) {
        this.objects[index].jobs[form.editId] = {
          ...this.objects[index].jobs[form.editId],
          ...form.form
        }
      } else {
        this.objects[this.objects.length - 1] = {
          ...this.objects[this.objects.length - 1],
          jobs: [...this.objects[this.objects.length - 1].jobs, form.form]
        }
      }

      this.objects = [...this.objects]
    },
    removeReport(form) {
      const index = this.objects.findIndex(({id}) => form.structureObj === id)
      if (index !== -1) {
        const reports = [
          ...(this.objects[index].jobs[form.editId].reports || [])
        ]

        const reportIndex = reports.findIndex(({id}) => id === form.form.id)

        if (reportIndex !== -1) {
          reports.splice(reportIndex, 1)

          this.objects[index].jobs[form.editId] = {
            ...this.objects[index].jobs[form.editId],
            reports: reports
          }

          this.objects[index] = {
            ...this.objects[index],
            jobs: [...this.objects[index].jobs]
          }

          this.objects = [...this.objects]
        }
      }
    },
    addJobs(form) {
      const index = this.objects.findIndex(({id}) => form.structureObj === id)

      if (index !== -1 && !form.editId && form.isCopy === true) {
        if (!this.objects[index].jobs) {
          this.objects[index].jobs = []
        }
        this.objects[index].jobs.push(form.form)
        this.objects = [...this.objects]
        return;
      }

      if (form.structureObj === null && index === -1) {
        this.objects.push({
          id: null,
          index: null,
          name: null,
          parentId: null,
          jobs: [],
        })

      } else if (index === -1) {
        return
      }

      if (index !== -1) {
        const reports = [
          ...(this.objects[index].jobs[form.editId].reports || [])
        ]

        const reportIndex = reports.findIndex(({id}) => id === form.reportId)


        if (reportIndex !== -1) {
          reports[reportIndex] = {
            objectName: this.objects[index].name,
            ...form.form,
          }
        } else {
          reports.push(form.form)
        }

        this.objects[index].jobs[form.editId] = {
          ...this.objects[index].jobs[form.editId],
          reports: reports
        }


        this.objects[index] = {
          ...this.objects[index],
          jobs: [...this.objects[index].jobs]
        }
      }


      this.objects = [...this.objects]

    },
    remove(obj) {
      if (obj.id) {
        this.objects = [...this.objects].filter(({id}) => id !== obj.id)
        return
      }
      this.objects = this.objects.filter((d) => {
        return !(d.name || '').startsWith(obj.name)
      })

      this.objects = [...this.objects]
    },
    openObj() {
      this.$refs.addObject.open(null)
    },
    insertObject(arr, newObj) {
      let maxMatch = 0;
      let insertIndex = arr.length;
      let newStr = newObj.name;

      for (let i = 0; i < arr.length; i++) {
        let currentStr = arr[i].name + ' >';
        let matchLength = 0;

        while (matchLength < currentStr.length && matchLength < newStr.length && currentStr[matchLength] === newStr[matchLength]) {
          matchLength++;
        }

        if (matchLength > maxMatch) {
          maxMatch = matchLength;
          insertIndex = i + 1;
        }
      }

      arr.splice(insertIndex, 0, newObj);
      return arr;
    },
    addObjects(objs) {
      if (!objs.length) {
        return
      }
      const objects = this.objects.filter(({id}) => id)


      if (objs[0].mainId || !objs[0].name.includes(' > ')) {
        this.objects = _.uniqBy([...this.objects, ...objs], 'id')
      } else {
        this.objects = _.uniqBy(this.insertObject(objects, objs[0]), 'id')
      }
    },
    openObjectEdit(object, name) {
      this.$refs.addObject.open(object, name)
    }
  }
}
</script>

<style scoped lang="scss">
.add-jobs-work {
  margin-top: 6px;
}

.search-jobs-work {
  display: flex;
  align-items: center;
}

.arrow-main {
  cursor: pointer;
  width: 32px;
  transform: rotate(90deg);


  &.hide {
    transform: rotate(-90deg) !important;
  }
}

.add-main-job {
  margin-top: 8px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: flex-end;

  span {
    font-size: 13px;
    font-weight: bold;
    margin-right: 4px;
    margin-left: 4px;
    color: #13ce66;
  }

  i {
    cursor: pointer;
    font-size: 30px;
  }
}

.precent {
  font-size: 13px;
  font-weight: bold;
  margin-right: 4px;
  margin-left: 4px;
  color: #13ce66;
}

.object-name {
  display: flex;
}

.object-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.object-name {
  display: flex;
  align-items: center;
  color: #000000;
  font-size: 14px;
  font-weight: bold;
}

.name {
  text-align: left;
}

.main-object-block {
  display: flex;
  flex-direction: column;
}

.job-inputs {
  display: flex;
  align-items: center;
  margin-right: 4px;

  i {
    padding-left: 4px;
    cursor: pointer;
  }
}

.input {
  margin-right: 8px;
}

.job-container {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.name-click {
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Workorder/components/AddJobsWork.vue